export default __webpack_public_path__ + "static/media/ZapReportsLogo.ee9f09d9.png";